import { BaseAPI } from "@utils/base-api";
import {
  StoreSufQuizRequest,
  StoreSufQuizResponse,
  SufQuizResponse,
} from "./suf-quiz-answers.types";

export class SufQuizAnswersAPI extends BaseAPI {

  /**
   * Store or update SUF quiz progress
   * Frontend must strip PII (email, firstName, lastName) before calling
   */
  public async storeSufQuizProgress(request: StoreSufQuizRequest): Promise<StoreSufQuizResponse> {
    const result = await this.axios.post<StoreSufQuizResponse>("/suf-quiz", request);
    return result.data;
  }

  /**
   * Get SUF quiz progress with PII for pre-population
   */
  public async getSufQuizProgress(formName: string, customerId: string): Promise<SufQuizResponse> {
    const result = await this.axios.get<SufQuizResponse>(`/suf-quiz/${formName}/${customerId}`);
    return result.data;
  }

}
